import { reportError } from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';
import type { ErrorPayload } from '@atlaskit/report-error';

export function platformErrorHandler(payload: ErrorPayload): void {
	reportError(payload.error, payload.errorInfo, { id: payload.interactionId });
}
